import {
  LayoutDashboard,
  Milestone,
  CheckSquare,
  Sparkles,
  LineChart,
  Flag,
  Activity,
  Shield,
  LayoutGrid,
  Inbox,
  Calendar,
  Settings as SettingsIcon,
  Bot,
  type LucideIcon,
} from "lucide-react";

export type NavId =
  | "overview"
  | "timeline"
  | "tasks"
  | "calendar"
  | "deliverables"
  | "wins"
  | "ttv"
  | "risks"
  | "pulse"
  | "criteria"
  | "proposals"
  | "admin"
  | "orin_admin";

export interface NavItem {
  id: NavId;
  label: string;
  icon: LucideIcon;
  shortcut: string;
  description: string;
}

export const NAV_ITEMS: NavItem[] = [
  { id: "overview", label: "Overview", icon: LayoutDashboard, shortcut: "g o", description: "Morning briefing and high-level progress" },
  { id: "timeline", label: "Gates & Dates", icon: Milestone, shortcut: "g t", description: "Visual timeline with gate checkpoints" },
  { id: "tasks", label: "Tasks", icon: CheckSquare, shortcut: "g d", description: "All tasks from the Deliverables Tracker, grouped by category" },
  { id: "calendar", label: "Calendar", icon: Calendar, shortcut: "g k", description: "Month view of every task with a due date — webinars, emails, gates" },
  { id: "proposals", label: "Proposals", icon: Inbox, shortcut: "g x", description: "AI-proposed updates from meeting transcripts — approve before they land" },
  { id: "deliverables", label: "Assets", icon: LayoutGrid, shortcut: "g b", description: "Shipping assets — click to open" },
  { id: "wins", label: "Felix Wins", icon: Sparkles, shortcut: "g w", description: "Customer quotes, call clips, and proof moments" },
  { id: "ttv", label: "TTV Metrics", icon: LineChart, shortcut: "g m", description: "Account-level time-to-value for A/B cohorts" },
  { id: "risks", label: "Risks & Flags", icon: Flag, shortcut: "g r", description: "Active risks ranked by severity" },
  { id: "pulse", label: "Weekly Pulse", icon: Activity, shortcut: "g p", description: "Weekly snapshot feeding Google Chat updates" },
  { id: "criteria", label: "Gate Criteria", icon: Shield, shortcut: "g c", description: "Admin-managed criteria for each gate" },
  { id: "admin", label: "Admin Settings", icon: SettingsIcon, shortcut: "g s", description: "Email digests, notification toggles — admin only" },
  { id: "orin_admin", label: "Orin Admin", icon: Bot, shortcut: "g i", description: "Inbox / Issues / Compose — Orin god-mode for verified admins" },
];
